import { Box } from '@material-ui/core';

import { SelectorCustomValue } from './SelectorCustomValue';
import { statusesEnum } from '../config';
import { useStyles } from '../styles';

interface TooltipProps {
  value: number;
  status: keyof typeof statusesEnum;
}

export const Tooltip = ({ value, status }: TooltipProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.tooltip}>
      <SelectorCustomValue statusValue={status} />: {value}
    </Box>
  );
};
